import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { TherapistForm, type TherapistData } from "./TherapistForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

type SiteOption = { id: number; name: string }

type Props = PageProps & {
  therapist: TherapistData
  sites: SiteOption[]
  photo_library: LibraryPhoto[]
}

export default function TherapistsEdit() {
  const { props } = usePage<Props>()
  const { therapist, sites, photo_library } = props

  return (
    <AdminShell>
      <Head title={`Edit ${therapist.name}`}>
        <meta name="description" content={`Edit therapist profile for ${therapist.name}.`} />
        <meta property="og:title" content={`Edit ${therapist.name}`} />
        <meta property="og:description" content={`Edit therapist profile for ${therapist.name}.`} />
      </Head>
      <Breadcrumbs
        items={[
          { label: "Website Pages", href: "/admin/website" },
          { label: "Therapy with Gisela", href: "/admin/website/pages/therapy-with-gisela" },
          { label: `${therapist.name}'s Profile` },
        ]}
      />
      <PageHeader title={`Edit — ${therapist.name}`} />
      <div className="mt-8 max-w-2xl">
        <TherapistForm
          therapist={therapist}
          sites={sites}
          actionUrl={`/admin/therapists/${therapist.id}`}
          method="patch"
          photoLibrary={photo_library}
        />
      </div>
    </AdminShell>
  )
}
